export const CUSTOM_PATH_RESPONSAVEL_REQUISICAO = 'requisicoes';
export const CUSTOM_PATH_RESPONSAVEL_COTACAO = 'cotacoes';
